import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Lessons", -1)
const _hoisted_2 = { class: "lesson" }
const _hoisted_3 = ["^href"]
const _hoisted_4 = ["textContent"]

import { Actions } from "@/store";
import { computed, onMounted } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Lessons',
  setup(__props) {

const store = useStore();
const lessons = computed(() => store.state.lessons);

onMounted(() => {
  store.dispatch(Actions.GetLessons);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessons.value, (lesson) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createElementVNode("h4", null, [
            _createElementVNode("a", {
              target: "_blank",
              "^href": lesson.url
            }, _toDisplayString(lesson.name), 9, _hoisted_3)
          ]),
          _createElementVNode("p", null, _toDisplayString(lesson.description), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(lesson.author) + " ", 1),
            _createElementVNode("i", {
              textContent: _toDisplayString(lesson.year)
            }, null, 8, _hoisted_4)
          ])
        ]))
      }), 256))
    ])
  ]))
}
}

})